import { Keys } from '@common/types';
import { EMPTY_STRING } from '@common/constants';
import { getSelectedRowsWithoutGroupIDs } from '@common/components/data-display/table/utils';
import { isEmpty } from 'lodash';

export const getNumberSelectedRow = (attribute: string, selectedRowKeys: Keys | []) => {
  const idsWithoutGroupIds = getSelectedRowsWithoutGroupIDs(selectedRowKeys);
  return `${attribute} ${!isEmpty(idsWithoutGroupIds) ? `(${idsWithoutGroupIds.length})` : EMPTY_STRING}`;
};
